import { render, staticRenderFns } from "./ModalNumberOfOffersItem.vue?vue&type=template&id=60ea5aab"
import script from "./ModalNumberOfOffersItem.vue?vue&type=script&lang=js"
export * from "./ModalNumberOfOffersItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports